export default "__VITE_ASSET__CPJNzrB$__"